var TyreAssistant = (function ($) {

    var addClickHandlerCloseBox = function () {
        $("#tyr-astnt-bx .ovr-bx-cls, #tyr-astnt-bx-mobile .ovr-bx-cls-mob").click(function () {
            $("#tyr-astnt-bx, #tyr-astnt-bx-mobile").css('display', 'none');
            localStorage.setItem("isHideTyreAssistantBox", true);
        });
    };

    return {
        addClickHandlerCloseBox: addClickHandlerCloseBox
    }
})(jQuery);

$(document).ready(function () {
    if (localStorage.getItem("isHideTyreAssistantBox") === "true") {
        $("#tyr-astnt-bx, #tyr-astnt-bx-mobile").css('display', 'none');
    } else {
        if ($("#tyr-astnt-bx").length || $("#tyr-astnt-bx-mobile").length) {
            TyreAssistant.addClickHandlerCloseBox();
        }
    }
});